import React from "react";
// import moment from "moment";
// import { BodyBuilder } from "../../exports/Images";
// import Slider from "react-slick";

const CarouselReact = () =>
  // { allData }
  {
    // function formatDate(dateString) {
    //   return moment(dateString).tz("Asia/Kolkata").format("DD-MM-YYYY");
    // }

    // var settings = {
    //   dots: false,
    //   arrows: false,
    //   draggable: true,
    //   autoplay: true,
    //   autoplaySpeed: 2000,
    //   speed: 500,
    //   infinite: false,
    //   slidesToShow: 6,
    //   slidesToScroll: 1,
    //   touchThreshold: 1000,
    //   pauseOnHover: true,
    //   cssEase: "linear",
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 600,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         initialSlide: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // };

    return (
      <>
        {/* <Slider {...settings}>
        {allData?.map((item, index) => (
          <div className="item" key={index}>
            <div className="owlItemInnerContainer greenCards">
              <div className="imgPositionName">
                <div className="img">
                  <img src={item?.profile || BodyBuilder} alt="profile-p" />
                </div>

                <div className="positionName">
                  <p className="name">{item?.name || "N/A"}</p>
                  <span className="position">{item?.plan_name || "N/A"}</span>
                  <span className="position date">
                    {formatDate(item?.date_added) || "-"}
                  </span>
                </div>
              </div>

              <div className="listFooter">
                <span className="listName">Amount Paid-</span>
                <p className="listValue">₹{item?.price || 0}</p>
              </div>

              <span className="taggedName">{item?.trainer_name || "N/A"}</span>
            </div>
          </div>
        ))}
      </Slider> */}
      </>
    );
  };

export default CarouselReact;
